import ownerPhoto from '../../../assets/owner.jpg';
import { Box, Flex, HStack, Icon, Image, List, Text, VStack } from '@chakra-ui/react';
import { FiChevronsRight } from 'react-icons/fi';

export function HomeAbout() {
	return (
		<Box id="o_nas" as="section" py={{ base: "8", md: "16" }} px={{ base: "4", md: "8" }}>
			<HStack
				gap={{ base: "4", md: "8" }}
				align="flex-start"
				flexDirection={{ base: "column", md: "row" }}
			>
				{/* Text Content */}
				<VStack
					flex={1}
					align="flex-start"
					gap="4"
				>
					<Text fontWeight="semibold" textTransform="uppercase" letterSpacing="wider">
						O nas
					</Text>
					<Text fontSize="md" lineHeight="1.8" color="gray.700">
						<Text as="span" color="orange.500" fontWeight="bold">Wiemy, z jakimi problemami mierzy się dzisiejsza młodzież i w jak bardzo przestarzałym środowisku szkolnym funkcjonuje.</Text>
						<br />
                        Obecny system edukacji oparty na modelu pruskim nie nadąża za błyskawicznie zmieniającym się światem i potrzebami dzieci. Zakaz opuszczania ławek przy jednoczesnym wymaganiu stałej koncentracji oraz program nauczania przeładowany suchą, encyklopedyczną wiedzą skutecznie zniechęcają do nauki. Często także nauczyciele, zamiast iść z duchem czasu od lat stosują w swojej pracy te same, przestarzałe metody.
					</Text>
					<List.Root as="ul" gap="2" color="gray.700" fontSize="md" lineHeight="1.8" pl="0" listStyleType="none">
						<Text as="span" color="orange.500" fontWeight="bold">Nasza wizja nauki jest zupełnie inna:</Text>
						<List.Item>
							<Flex align="flex-start" gap="3">
								<Icon as={FiChevronsRight} color="orange.500" boxSize="5" mt="1" flexShrink={0} />
								<Text>Stosujemy nowoczesne, kreatywne metody nauczania - edukacyjne gry i ruch doskonale podtrzymują koncentrację</Text>
							</Flex>
						</List.Item>
						<List.Item>
							<Flex align="flex-start" gap="3">
								<Icon as={FiChevronsRight} color="orange.500" boxSize="5" mt="1" flexShrink={0} />
								<Text>Uczymy jak mądrze wykorzystywać sztuczną inteligencję w procesie nauki - tworzymy fiszki i quizy zamiast szukać gotowych rozwiązań</Text>
							</Flex>
						</List.Item>
						<List.Item>
							<Flex align="flex-start" gap="3">
								<Icon as={FiChevronsRight} color="orange.500" boxSize="5" mt="1" flexShrink={0} />
								<Text>Stawiamy na zajęcia stacjonarne w mikrogrupach - każdemu poświęcamy odpowiednią ilość uwagi</Text>
							</Flex>
						</List.Item>
					</List.Root>
				</VStack>

				{/* Image with Caption */}
				<VStack
					flex={1}
					align="center"
					gap="3"
				>
					<Image
						src={ownerPhoto}
						alt="Dominik Soszyński"
						borderRadius="lg"
						boxShadow="md"
						width="100%"
						maxW="400px"
						objectFit="cover"
						aspectRatio="square"
					/>
					<Text fontSize="sm" color="gray.600" textAlign="center" maxW="400px">
						Dominik Soszyński
                        <br/>
                        założyciel Centrum Korepetycji Opanuj.to
					</Text>
				</VStack>
			</HStack>
		</Box>
	);
}
